import { ReportExportFormat } from "./report-export-format.enum";

/**
 * Returns whether a report template supports the requested export format.
 *
 * XLSX intentionally reuses the template's PDF capability because the
 * report template model only distinguishes PDF-capable grid exports from XML.
 */
export const reportSupportsExportFormat = <OutputType extends string>(
  outputTypes: readonly OutputType[] | null | undefined,
  exportFormat: ReportExportFormat,
): boolean => {
  if (exportFormat === ReportExportFormat.XML) {
    return outputTypes?.some((outputType) => outputType === ReportExportFormat.XML) ?? false;
  }

  return outputTypes?.some((outputType) => outputType === ReportExportFormat.PDF) ?? false;
};

/** Returns whether the export format has a first-class grouped export contract. */
export const supportsGroupedReportExportFormat = (exportFormat: ReportExportFormat): boolean =>
  exportFormat === ReportExportFormat.PDF || exportFormat === ReportExportFormat.XLSX;
